export default "/images/22cd6170f5bf99bd5888722fd00ad352.png";